import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { appActions } from '../../../reducers/app.reducer';
import HelmetTemplate from './HelmetTemplate.react';
// import PageNotFound from './PageNotFound.react';
import RestoreScroll from './RestoreScroll.react';
// import Sitemap from './Sitemap.react';

import LandingPage from '../LandingPage.react';
import OurPurpose from '../../our-purpose/OurPurpose.react';
import HydroTip from '../../hydro-tip/HydroTip.react';
import ArticlePage from '../../articles/ArticlePage.react';

// https://www.amitsn.com/blog/how-to-generate-a-sitemap-for-your-react-website-with-dynamic-content

var Router = function Router(_ref) {
  var gaPageViewAction = _ref.gaPageViewAction;
  var pages = useSelector(function (s) {
    return s.pages;
  });
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(function () {
    gaPageViewAction({
      pathname: pathname === '/' ? pathname : pathname.replace(/\/$/, '')
    });
  }, [pathname]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HelmetTemplate, null), /*#__PURE__*/React.createElement(RestoreScroll, null), /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    element: /*#__PURE__*/React.createElement(LandingPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/our-purpose",
    element: /*#__PURE__*/React.createElement(OurPurpose, null)
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/hydrotip",
    element: /*#__PURE__*/React.createElement(HydroTip, null)
  }), Object.values(pages).map(function (x) {
    if (x.type !== 'article-page') return;
    return /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: x.internalUrl,
      element: /*#__PURE__*/React.createElement(ArticlePage, null),
      key: x._id
    });
  }), Object.values(pages).map(function (x) {
    if (x.type !== 'article-page') return;
    return /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "".concat(x.internalUrl, "/:articleID"),
      element: /*#__PURE__*/React.createElement(ArticlePage, null),
      key: "".concat(x._id, "-articleID")
    });
  })));
};
var mdtp = {
  gaPageViewAction: appActions.gaPageView
};
export default connect(null, mdtp)(Router);